"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hist = void 0;

var _type = require("../type/type");

var _is = require("../is/is");

/**
 * Count the number of occurances of each element
 *
 * @param  {Array}  source  Source input
 *
 * @return {Object}
 */
var byArray = function byArray(source) {
  var result = {};

  for (var i = 0, length = source.length - 1; i <= length; i++) {
    result[source[i]] = (0, _is.is)(result[source[i]]) ? result[source[i]] + 1 : 1;
  }

  return result;
};
/**
 * Count the number of occurances of each object by a field
 *
 * @param  {string}  field  The field
 *
 * @return {Object}
 */


var byKey = function byKey(field) {
  return function (source) {
    var result = {};

    for (var i = 0, length = source.length; i < length; i++) {
      if (!!source[i][field]) {
        var groupKey = String(source[i][field]);
        result[groupKey] = result[groupKey] ? result[groupKey] + 1 : 1;
      }
    }

    return result;
  };
};

var byType = {
  Array: byArray,
  String: byKey
};
/**
 * Determine the count of all field's distinct values in a list of objects
 * (aka histogram)
 *
 * @tag Array
 * @signature (field: string)(source: Object[]): Object
 *
 * @param   {string}    field   Field name to count
 * @param   {Object[]}  source  Array of objects
 *
 * @return  {Object}
 *
 * @example
 *
 * const scores = [{
 *  name   : "Bob",
 *  score  : 1,
 *  subject: "Math"
 * }, {
 *  name   : "Alice",
 *  score  : 10,
 *  subject: "Math"
 * }, {
 *  name   : "Hatter",
 *  score  : 10,
 *  subject: "Math"
 * }]
 *
 * hist( "score" )( scores )
 * // => { "1": 1, "10": 2 }
 */

var hist = function hist(field) {
  return byType[(0, _type.type)(field)](field);
};

exports.hist = hist;